import { render, staticRenderFns } from "./CreateLeadEvent.vue?vue&type=template&id=42118e4a&"
import script from "./CreateLeadEvent.vue?vue&type=script&lang=js&"
export * from "./CreateLeadEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports